var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle, _path29, _path30, _path31;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgreement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 406 612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m321 492-1 1a118 118 0 0 0-11 16l-1 1a125 125 0 0 0-16 43l-1 11-1 8c0 11 1 23-6 32a23 23 0 0 1-7 6 29 29 0 0 1-6 2h-23l-4-1-1 1v-2c-1-27 1-54 13-76a85 85 0 0 1 17-22c12-12 29-20 47-20h1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M321 493a106 106 0 0 0-46 46 46 46 0 0 0-5 13 26 26 0 0 0 2 14c2 4 4 8 4 13a16 16 0 0 1-4 12c-3 4-8 7-13 10-6 2-12 5-15 10-1 1-2 0-1-1 6-8 18-10 26-17 4-4 6-8 6-13s-2-9-4-13a28 28 0 0 1-2-13 42 42 0 0 1 4-14 103 103 0 0 1 18-26 108 108 0 0 1 29-22c1-1 2 0 1 1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M278 532a16 16 0 0 1-6-19h2a15 15 0 0 0 5 18l-1 1Zm-7 32a31 31 0 0 0 19-11h1a32 32 0 0 1-20 12v-1Zm29-58a9 9 0 0 0 8 3l1 1a10 10 0 0 1-9-3 1 1 0 0 1-1-1 1 1 0 0 1 1 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M376 565h-1a119 119 0 0 0-19 6h-1a125 125 0 0 0-39 25 122 122 0 0 0-12 14l-2 2h-60 1v-1l1-1 2-3a178 178 0 0 1 29-32 115 115 0 0 1 16-11l9-5a85 85 0 0 1 25-7h1a68 68 0 0 1 50 13Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M242 612h17a39 39 0 0 0-16 0h-1Zm134-47h-1a105 105 0 0 0-24-1h-1a105 105 0 0 0-31 7h-1l-7 3a46 46 0 0 0-12 8 25 25 0 0 0-6 10v2c-2 4-2 9-5 13a15 15 0 0 1-2 3 15 15 0 0 1-3 2h-2a15 15 0 0 0 4-2 13 13 0 0 0 2-3l4-13 1-2a27 27 0 0 1 6-10 42 42 0 0 1 11-8l8-4h1a108 108 0 0 1 57-6h1v1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M318 571a16 16 0 0 1 7-19c1-1 2 0 1 1a15 15 0 0 0-7 17l-1 1Zm-25 21a31 31 0 0 0 22 2v1a32 32 0 0 1-23-2l1-1Zm58-29a9 9 0 0 0 5 7v1a10 10 0 0 1-6-7 1 1 0 0 1 1-1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M317 166q0-49 4-100v-2l5-53a11 11 0 0 0-11-11H20A11 11 0 0 0 9 11L3 84v2l-2 36v2a1479 1479 0 0 0 8 218 11 11 0 0 0 11 11h295a11 11 0 0 0 11-11l-4-39v-6l-2-28-1-6-2-57v-40Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M406 75a11 11 0 0 0-11-11H100a11 11 0 0 0-11 11c-10 95-12 188-5 278l3 33 2 18v2a11 11 0 0 0 11 11h295a11 11 0 0 0 11-11c-12-106-12-217 0-331Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#e4e4e4",
    d: "M406 75a11 11 0 0 0-11-11H100a11 11 0 0 0-11 11c-10 95-12 188-5 278l3 33 2 18v2a11 11 0 0 0 11 11h295a11 11 0 0 0 11-11c-12-106-12-217 0-331Zm-2 331a9 9 0 0 1-9 9H100a9 9 0 0 1-9-9v-2l-2-18-3-33c-7-90-5-183 5-278a9 9 0 0 1 9-9h295a9 9 0 0 1 9 9c-12 114-12 225 0 331Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M120 166a3 3 0 0 0 0 6h240a3 3 0 0 0 0-6Z",
    "data-name": "Path 142"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M120 183a3 3 0 0 0 0 6h163a3 3 0 0 0 0-6Z",
    "data-name": "Path 143"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M120 200a3 3 0 0 0 0 6h240a3 3 0 0 0 0-6Z",
    "data-name": "Path 142"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M120 218a3 3 0 0 0 0 5h163a3 3 0 0 0 0-5Z",
    "data-name": "Path 143"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M120 263a3 3 0 0 0 0 6h240a3 3 0 0 0 0-6Z",
    "data-name": "Path 142"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M120 280a3 3 0 0 0 0 6h163a3 3 0 0 0 0-6Z",
    "data-name": "Path 143"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M120 297a3 3 0 0 0 0 6h240a3 3 0 0 0 0-6Z",
    "data-name": "Path 142"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M120 315a3 3 0 0 0 0 5h163a3 3 0 0 0 0-5Z",
    "data-name": "Path 143"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M168 131h-46a2 2 0 0 1-2-3v-7a2 2 0 0 1 2-2h46a2 2 0 0 1 2 2v7a2 2 0 0 1-2 3Z",
    "data-name": "Path 154"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m327 367-14 4-7 3-7 1c-2 0-4-1-4-3l2-4c3-3 7 0 10 3l7 10a26 26 0 0 0 9 8c7 3 15 3 22-2 7-6 8-16 8-24a2 2 0 0 0-3 0c0 7-1 17-8 22s-16 3-22-2l-8-10c-2-4-5-7-9-9a8 8 0 0 0-10 4 6 6 0 0 0 3 9c5 2 10 0 15-2l17-5c1-1 1-4-1-3Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#9f616a",
    d: "m285 587-10 3-17-36 15-5 12 38z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M292 595v-2l-2-5-1-4-4 2v-1h-14l-5 7a15 15 0 0 0-9 8h-1a13 13 0 0 0 0 2 15 15 0 0 0-1 8 17 17 0 0 0 1 1v1h1l6-2 22-8 5-1 1-1h3Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#9f616a",
    d: "M192 596h-10l-5-40h15v40z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m175 421-4 8s-5 1-4 17c2 12 2 64 5 98 1 14 3 25 5 28l2 2 15 1 6-39a66 66 0 0 0-1-21l-1-11 14-56s14 36 23 70c2 8 11 13 14 20l3 7c6 14 10 25 12 26h2l12-4 2-6-18-54-14-88c-26-14-50-15-73 2Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M250 303a41 41 0 0 0-3-6 29 29 0 0 0-11-10l-4-1-7-1-4-5-6-6h-21l-3 6-2 6-1 3-18 9 1 5 1 12 1 5 2 18 1 15a334 334 0 0 1 0 34l2 8c0 5-4 8-4 12l-1 8a8 8 0 0 1-1 2c-7 13-1 7-2 10h2c4 1 21-15 33-15 7 0 26 11 32 12 5 1 9 1 12-1a6 6 0 0 0 2-2v-1l-1-3v-2l-2-29a10 10 0 0 1-1-10v-1l-1-22-1-4v-1l-1-11 2-6 4-11 2-5 1-4a41 41 0 0 0-3-8Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#9f616a",
    d: "m269 406-20-52-10-19 18-10 15 26 9 53a9 9 0 1 1-12 2Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m269 335-5-4-6-11-3-5-2-4-1-2-9-6-6-4-5 4-3 2 3 10 1 5 3 13 9 16 3 4 1 2v1l23-1h1v-3a37 37 0 0 0-4-17Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#9f616a",
    d: "m93 386 41-38 15-16 15 14-18 22-46 29a9 9 0 1 1-7-11Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M178 320v-22a8 8 0 0 0-3-1 9 9 0 0 0-3 0 10 10 0 0 0-2 1 17 17 0 0 0-7 5 75 75 0 0 0-8 12l-4 5-6 14-12 14 1 1 2 4 9 16 2 2 3-2a22 22 0 0 0 10-10l1-5 1-1 13-15 3-5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 599.6,
    cy: 406.3,
    r: 19.3,
    fill: "#9f616a",
    transform: "rotate(-81 310 562)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m184 238-2-5 2-2h1l1-3s0-2 1-1 0 1 1-1l2-2s8 1 10-1 15 0 18 2 15 6 8 18c4 7-2 19-3 21-3 2-5 3-16 5-2 1-8-18-8-18s-14-10-15-13Zm9 356h-1l-11-5h-2l-7 5a15 15 0 0 0-15 16h39v-16Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M309 611a1 1 0 0 1-1 1H104a1 1 0 0 1 0-2h204a1 1 0 0 1 1 1Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M99 0A134 134 0 0 1 1 122v2A136 136 0 0 0 101 0ZM68 0A135 135 0 0 1 3 84v2A137 137 0 0 0 70 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreement);
export default __webpack_public_path__ + "static/media/agreement.00e9dfc737cd5d9381b528605c8fc2ba.svg";
export { ForwardRef as ReactComponent };